/**
 * Global cart functions
 */

import { fetchCart, updateCartCount, submitAddToCartForm } from './cart-functions';
import { updateCart } from './cart-drawer';
import { initPromoChooserDrawer } from './promo-chooser-drawer';

// Expose the function to the global scope so it can be used in other modules
// e.g. used by the Algolia hits widget in browse.ts
window.submitAddToCartForm = submitAddToCartForm;

document.addEventListener('DOMContentLoaded', async () => {
  // Wire up the add-to-cart UI first. None of it depends on cart data, so it must not be
  // gated by the cart fetch below — if fetchCart() fails, the page must still be usable.

  // Enable add to cart buttons
  const atcButtons = document.querySelectorAll<HTMLButtonElement>('.js-atc');
  atcButtons.forEach((btn) => {
    btn.disabled = btn.dataset.disabled ? true : false;
  });

  // Hook up add to cart forms
  const addToCartForms = document.querySelectorAll<HTMLFormElement>('.js-add-to-cart-form');
  addToCartForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submitAddToCartForm(form);
    });
  });

  // ATC promo chooser (§4): listens for the server's "choose a promo" signal and owns its drawer.
  initPromoChooserDrawer();

  // Best-effort cart fetch — fetchCart() returns undefined on any failure. A failed fetch
  // must degrade to "cart not populated this load", never throw and halt the wiring above.
  const cart = await fetchCart('compact');
  if (cart) {
    updateCart(cart);
    updateCartCount(cart);
  }
});
